
<template>
  <div class="ergebnis-liste">
    <h2>{{ lcCenter.length }} {{ $t('searchlist.heading') }}
      <span v-if="region.length > 0 && regionsText">
        <span v-if="orderBy == 'ort'">{{ $t('searchlist.area') }}</span>
        <span v-else>in</span> {{ getRegionName(getLastRegion()) }}
      </span>
    </h2>

    <!-- <div class="infotext" v-if="orderBy == 'ort'">{{ $t('searchlist.sorting') }} {{radiusMap}} km</div> -->

    <div v-if="lcCenter && lcCenter.length > 1">
      <div v-if="orderBy == 'ort'"><span class="infotext">{{ $t('searchlist.regionSearch') }} {{ radiusMap }} km - {{
        $t('searchlist.regionInfo')
      }}</span></div>
      <div v-if="orderBy == 'bund'"><span class="infotext">{{ $t('searchlist.sorting') }} {{
        $t('searchlist.plz')
      }}</span></div>
    </div>

    <div class="ergebnis-liste-tags" style="min-height: 45px;" :style="(!mini && listTopics.length > 0 ? 'margin-bottom:70px;' : '')">
      <div v-if="!mini && listTopics.length > 0">
        <span class="infotext">{{ $t('searchlist.selectedTopics') }}:</span>
        <div class="tags mt-2">
          <button v-for="(topic, index) in listTopics" :key="index" class="btn tag tag-with-close text-break"
            @click="deleteTopic(topic)">
            <span class="visually-hidden">{{ $t('searchlist.deleteTag') }}</span> {{ getNameById(topic) }}
          </button>
        </div>
      </div>
      <div class="float-end" v-if="lcCenter && lcCenter.length > 0">
          <span class="consistent-width">
            <span>{{ $t('searchlist.chat') }}</span><span>{{ $t('searchlist.beratung') }}</span>
          </span>
          <span class="consistent-width">
            <span>{{ $t('searchlist.video') }}</span><span>{{ $t('searchlist.beratung') }}</span>
          </span>
          <span class="consistent-width">
            <span>{{ $t('searchlist.mail') }}</span><span>{{ $t('searchlist.beratung') }}</span>
          </span>
        </div>
    </div>

    <div v-if="lcCenter && lcCenter.length > 0" id="ergebnis-liste">
      <div class="ergebnis-liste-eintrag" v-for="(center, index) in lcCenter" :key="index">
        <div class="eintrag--kontakt">
          <div class="eintrag-title">
            <router-link :to="{
              name: 'counseling-center',
              params: { ccid: center.id, topics: topics, region: region, lang: lang, cType: cType, targetGroup: targetGroup, backlink: 'y' }
            }">{{ center.name }}
            </router-link>
          </div>
          <div class="eintrag-info">{{ center.legalEntities[0]?.name }}</div>
          <div class="eintrag-adresse">{{ center.address.zipCode }} {{ center.address.city }}<span
              v-if="center.address && (center.address.streetName || center.address.houseNumber || center.address.addressSupplement)">,
            </span>{{ center.address.streetName }} {{ center.address.houseNumber }} {{
              center.address.addressSupplement
            }}
          </div>
        </div>
        <div v-if="center.chatCounselingSystem && center.chatCounselingSystem !== 'NONE'"
          class="float-right onb-contact--link--chat">
          <!-- <router-link :to="{
              name: 'counseling-center',
              params: { ccid: center.id, topics: topics, region: region, lang: lang, cType: cType, targetGroup: targetGroup, backlink: 'y' }
            }"> -->
            <i class="icon onb-contact--chat" :aria-label="`die Beratungsstelle ${center.name} bietet Chat-Beratung an`" tabindex="0"></i>
            <!-- </router-link> -->
        </div>
        <div v-if="center.videoCounselingSystem && center.videoCounselingSystem !== 'NONE'"
          class="float-right onb-contact--link--video">
          <!-- <router-link :to="{
              name: 'counseling-center',
              params: { ccid: center.id, topics: topics, region: region, lang: lang, cType: cType, targetGroup: targetGroup, backlink: 'y' }
            }"> -->
            <i class="icon onb-contact--video" :aria-label="`die Beratungsstelle ${center.name} bietet Video-Beratung an`" tabindex="0"></i>
            <!-- </router-link> -->
        </div>
        <div v-if="center.mailCounselingSystem && center.mailCounselingSystem !== 'NONE'" href="#"
          class="float-right onb-contact--link--mail">
          <!-- <router-link :to="{
              name: 'counseling-center',
              params: { ccid: center.id, topics: topics, region: region, lang: lang, cType: cType, targetGroup: targetGroup, backlink: 'y' }
            }"> -->
            <i class="icon onb-contact--mail" :aria-label="`die Beratungsstelle ${center.name} bietet Mail-Beratung an`" tabindex="0"></i>
            <!-- </router-link> -->
        </div>
      </div>
    </div>

    <div v-else>
      {{ $t('searchlist.notFound') }}

      <div
        v-if="(lang && lang.length > 0) || (cType && cType.length > 0) || (targetGroup && targetGroup.length > 0) || (searchTerm && searchTerm.length > 0)"
        class="mt-4">
        <div class="btn btn-link-custom d-inline-block px-0 mx-0" id="btn-filter-reset" @click="resetFilter()">{{
          $t('searchlist.resetFilter')
        }}
        </div>
      </div>
    </div>

  </div> <!-- ergebnis-liste -->
</template>

<script lang="ts">
import lookupValuesService from '@/services/lookupValuesService';
import { defineComponent } from 'vue'
import CONFIG from "@/config/config"

export default defineComponent({
  name: 'Liste',
  props: {
    topics: { type: Array },
    cCenter: { type: Object },
    lang: { type: Array },
    cType: { type: Array },
    targetGroup: { type: String || Array },
    region: { type: String, default: '' },
    long: { type: String, default: '' },
    lat: { type: String, default: '' },
    os: { type: Array },
    radiusMap: { type: Number, default: 40 },
    searchTerm: { stype: String, default: '' },
    mini: { type: Boolean, default: false }
  },
  emits: ['submit', 'resetfilter'],
  data() {
    return {
      config: CONFIG,
      listTopics: this.topics as any,
      lcCenter: this.cCenter,
      listlang: this.lang as any,
      listOs: this.os as any,
      listcType: this.cType as any,
      listtargetGroup: this.targetGroup as any,
      orderBy: '',
      regionsText: true,
      savedRegionText: JSON.parse(JSON.stringify(this.region))
    }
  },
  mounted() {
    // console.log('list-mounted:',this.topics, this.listTopics)

    if (this.region) {
      this.orderBy = 'bund'
    }
    if (this.long && this.lat) {
      this.orderBy = 'ort'
    }
    if (this.region === 'all') {
      this.orderBy = ''
      this.regionsText = false
    }
  },
  methods: {
    getLastRegion() {
      return this.savedRegionText;
    },
    linkToCC(id: string) {
      return `#/counseling-center/${id}`;
    },
    resetFilter() {
      this.$emit('resetfilter')
    },
    getNameById(id: string) {
      const test = lookupValuesService.getLookupValueById(this.getStore, 'TOPIC', id);
      return test.description
    },
    pushUrl() {
      this.$router.push({
        params: {
          ctype: this.listcType,
          lang: this.listlang,
          topic: this.listTopics,
          tg: this.listtargetGroup,
          os: this.listOs,
          region: this.region,
          long: this.long,
          lat: this.lat,
          radius: this.radiusMap
        }
      })
      // this.savedRegionText = JSON.parse(JSON.stringify(this.region));
      // if (this.config && this.config.baseSearchHref) {
      //     const params: any = {
      //       topic: this.listTopics,
      //       ctype: this.listcType,
      //       tg: this.listtargetGroup,
      //       lang: this.listlang,
      //       region: this.region
      //     }
      //     // console.log((this as any).config.baseSearchHref + '#?' + qs.stringify(params, { indices: false }))
      //     setTimeout(() => {
      //       location.href = (this as any).config.baseSearchHref + '#?' + qs.stringify(params, { indices: false });
      //     }, 300);
      //   }
    },
    deleteTopic(id: any) {
      let newTopicList: any = Object.values(this.listTopics)
      const index = newTopicList.indexOf(id);
      if (index > -1) {
        newTopicList.splice(index, 1); // 2nd parameter means remove one item only
      }
      this.listTopics = newTopicList
      this.pushUrl()
      let selectedCoords = [];
      selectedCoords.push(this.lat)
      selectedCoords.push(this.long)
      this.$emit('submit', this.listTopics, this.region, selectedCoords, this.radiusMap);
      // this.$emit('submit', this.listTopics);

    },
    getRegionName(region: string) {
      if (region.toLowerCase() === "wien" || region.toLowerCase() === "vienna") {
        return this.$t("common.region.VIENNA");
      } else if (region.toLowerCase() === "niederösterreich" || region.toLowerCase() === "lower_austria") {
        return this.$t("common.region.LOWER_AUSTRIA");
      } else if (region.toLowerCase() === "oberösterreich" || region.toLowerCase() === "upper_austria") {
        return this.$t("common.region.UPPER_AUSTRIA");
      } else if (region.toLowerCase() === "salzburg" || region.toLowerCase() === "salzburg") {
        return this.$t("common.region.SALZBURG");
      } else if (region.toLowerCase() === "steiermark" || region.toLowerCase() === "styria") {
        return this.$t("common.region.STYRIA");
      } else if (region.toLowerCase() === "burgenland" || region.toLowerCase() === "burgenland") {
        return this.$t("common.region.BURGENLAND");
      } else if (region.toLowerCase() === "kärnten" || region.toLowerCase() === "carinthia") {
        return this.$t("common.region.CARINTHIA");
      } else if (region.toLowerCase() === "tirol" || region.toLowerCase() === "tyrol") {
        return this.$t("common.region.TYROL");
      } else if (region.toLowerCase() === "vorarlberg" || region.toLowerCase() === "vorarlberg") {
        return this.$t("common.region.VORARLBERG");
      } else if (region === 'all') {
        return this.$t("common.region.ALL");
      } else {
        return region;
      }
    }
  },
  computed: {
    getStore(): any {
      return this.$store.state.lookUpValues
    },
  },
});
</script>

<style scoped>
.eintrag-info,
.eintrag-adresse {
  color: black;
}

.ergebnis-liste-eintrag a:hover {
  text-decoration: none;
}

.tag-with-close {
  margin-bottom: 6px;
}

.frauen .btn-link-custom {
  color: #870038 !important
}

.familie .btn-link-custom {
  color: #217cab !important
}

.consistent-width {
  display: inline-flex;
  flex-direction: column;
  /* Aligns children vertically */
  align-items: center;
  /* Centers the children horizontally */
  white-space: normal;
  /* Overrides any nowrap */
  margin-right: 10px;
  /* Adds spacing between items */
}

.icon {
  margin-right: 5px;
}

.icon:focus {
  background-color: #000;
}

.consistent-width::before {
  content: "";
  white-space: pre-line;
}

.consistent-width span {
  display: block;
  /* Ensures that the text in span behaves like block elements, allowing breaks */
}

</style>
